import { DirectiveBinding } from 'vue';

// Use a Map to store handlers associated with each element
const handlers = new Map<HTMLElement, (event: MouseEvent) => void>();

const vClickOutside = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const handler = (event: MouseEvent) => {
      // Check if the clicked element is outside the bound element
      // and not the bound element itself
      if (!el.contains(event.target as Node) && el !== event.target) {
        binding.value(event); // Execute the provided callback
      }
    };

    // Store the handler
    handlers.set(el, handler);

    // Add event listener directly
    document.addEventListener('click', handler);
  },
  unmounted(el: HTMLElement) {
    // Retrieve and remove the handler
    const handler = handlers.get(el);
    if (handler) {
      document.removeEventListener('click', handler);
      handlers.delete(el); // Clean up the Map
    }
  },
};

export default vClickOutside;